<script setup>
import { ref, computed, defineProps } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { User, ArrowDown } from '@element-plus/icons-vue';
import font from '@/assets/font.png'
import { useUserStore } from '@/store/user';

const userStore = useUserStore();

defineProps({
  showMenu: {
    type: Boolean,
    default: true
  }
})

const route = useRoute()
const router = useRouter();
const onRoutes = computed(() => route.path)

// 直接使用 store 响应式数据
const token = computed(() => userStore.token);
const userInfo = computed(() => userStore.user);

const handleLogin = () => {
  window.open('/login', '_blank');
};

const handleCommand = (command) => {
  if (command === 'logout') handleLogout();
}

const toMyWorkbench = () => {
  if (!token.value) return;
  const role = userInfo.value?.role;
  if (role === 'admin') {
    window.open('/activity-manage', '_blank');
  } else if (role === 'student') {
    window.open('/my-work-list', '_blank');
  } else if (role === 'reviewer') {
    window.open('/review', '_blank');
  } else if (role === 'employee') {
    window.open('/emp-sti-manage', '_blank');
  }
}

// 退出登录（修复版）
const handleLogout = () => {
  userStore.logout();
  router.push('/login');
};

const toHome = () => {
  router.push('/');
}
</script>

<template>
  <nav class="navbar">
    <img :src="font" alt="font-icon" @click="toHome" style="width: 120px; height: 26px;"/>
    
    <div style="width: 100%;" v-if="showMenu">
      <el-menu 
        router 
        :default-active="onRoutes" 
        mode="horizontal"
        :ellipsis="false"
      >
        <el-menu-item index="/notice">新闻公告</el-menu-item>
        <el-menu-item index="/activity-list">创新赛事</el-menu-item>
        <el-menu-item index="/work-track">科创作品跟踪</el-menu-item>
      </el-menu>
    </div>

    <div class="user-info">
      <el-button type="primary" v-if="token" @click="toMyWorkbench">工作台</el-button>

      <el-dropdown @command="handleCommand" v-if="token">
        <span class="username">
          {{ userInfo.username }}
          <el-icon class="el-icon--right">
            <arrow-down />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <el-button type="text" class="login-btn" @click="handleLogin" v-if="!token">
        登录
      </el-button>
    </div>
  </nav>
</template>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: grid;
  grid-template-areas: "left center right";
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 20px;
  height: 60px;
  background-color: #fff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.logo {
  font-size: 18px;
  font-weight: bold;
  color: #165DFF;
  margin-right: auto;
}

.ai-text {
  font-family: "Arial Black", sans-serif;
  font-size: 25px;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  background-image: url('@/assets/home1.png');
  background-size: 50px 20px;
  -webkit-text-stroke: 1px #6680e7;
}

.user-info {
  display: flex;
  align-items: center;
  grid-area: right;
  justify-self: end;
  font-size: 18px;
}

.username {
  color: #666;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.login-btn {
  color: #165DFF;
}
.logout-btn {
  color: #f56c6c;
}
</style>